"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var layer_1 = require("../../layer");
var utils_1 = require("../utils");
var WCSLayer = /** @class */ (function (_super) {
    __extends(WCSLayer, _super);
    function WCSLayer(options) {
        var _this = _super.call(this, options) || this;
        _this.description = _this.capabilities.then(function (caps) {
            return (0, utils_1.fetchCoverageDescriptionFromCapabilities)(caps, _this.id, {
                debug: options.debug,
                fetch: _this.fetch,
                wait: options.wait,
            });
        });
        return _this;
    }
    // get extent as a [west, south, east, north]
    WCSLayer.prototype.getExtent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // sometimes DescribeCoverage will take a long time,
                // so use GetCapabilities if it is resolves more quickly
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var count = 0;
                        var resolved = false;
                        _this.capabilities.then(function (caps) {
                            var _a;
                            if (!resolved) {
                                count += 1;
                                var bbox = (_a = (0, utils_1.findAndParseCoverage)(caps, _this.id)) === null || _a === void 0 ? void 0 : _a.wgs84bbox;
                                if (bbox) {
                                    resolved = true;
                                    resolve(bbox);
                                }
                                else if (count === 2) {
                                    reject(Error("unable to get extent"));
                                }
                            }
                        });
                        _this.description.then(function (description) {
                            if (!resolved) {
                                count += 1;
                                var bbox = (0, utils_1.findAndParseExtent)(description);
                                if (bbox) {
                                    resolved = true;
                                    resolve(bbox);
                                }
                                else if (count === 2) {
                                    reject(Error("unable to get extent"));
                                }
                            }
                        });
                    })];
            });
        });
    };
    WCSLayer.prototype.getImageUrl = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            var _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _a = utils_1.createGetCoverageUrl;
                        _d = {};
                        return [4 /*yield*/, this.capabilities];
                    case 1:
                        _b = [__assign.apply(void 0, [(_d.capabilities = _f.sent(), _d.layerId = this.id, _d), options])];
                        _e = {};
                        _c = options.bbox;
                        if (_c) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getExtent()];
                    case 2:
                        _c = (_f.sent());
                        _f.label = 3;
                    case 3: return [2 /*return*/, _a.apply(void 0, [__assign.apply(void 0, _b.concat([(
                                // use coverage extent if no bbox provided
                                _e.bbox = _c, _e)]))])];
                }
            });
        });
    };
    WCSLayer.prototype.getImage = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getImageUrl(options)];
                    case 1:
                        url = _a.sent();
                        return [4 /*yield*/, this.fetch(url)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.arrayBuffer()];
                }
            });
        });
    };
    WCSLayer.prototype.getLayerDates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = utils_1.parseDates;
                        return [4 /*yield*/, this.description];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    };
    WCSLayer.prototype.getLayerDayRanges = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = utils_1.parseLayerDays;
                        return [4 /*yield*/, this.description];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    };
    return WCSLayer;
}(layer_1.Layer));
exports.default = WCSLayer;
